(function () {
  if (window.EmpireInk2026Tracking) return;
  window.EmpireInk2026Tracking = true;

  function track(eventName, element) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      empire_link_url: element && element.href ? element.href : undefined,
      empire_link_text: element && element.textContent ? element.textContent.trim() : undefined,
      empire_page_path: window.location.pathname
    });
  }

  document.addEventListener('click', function (event) {
    var target = event.target.closest('[data-ei-track]');
    if (!target) return;
    track(target.getAttribute('data-ei-track'), target);
  });

  document.addEventListener('submit', function (event) {
    if (!event.target.closest('[data-ei-booking-area]')) return;
    track('empire_booking_submit', event.target);
  });

  var activeTeamDialog = null;
  var activeTeamDialogOpener = null;
  var teamDialogTimer = 0;

  function lockTeamDialogScroll(locked) {
    document.documentElement.classList.toggle('ei2026-team-dialog-open', locked);
    document.body.classList.toggle('ei2026-team-dialog-open', locked);
  }

  function closeTeamDialog(dialog, immediate) {
    if (!dialog) return;

    window.clearTimeout(teamDialogTimer);
    dialog.classList.remove('is-open');
    dialog.setAttribute('aria-hidden', 'true');

    var opener = activeTeamDialog === dialog ? activeTeamDialogOpener : null;
    if (activeTeamDialog === dialog) {
      activeTeamDialog = null;
      activeTeamDialogOpener = null;
      lockTeamDialogScroll(false);
    }

    function finishClose() {
      if (!dialog.classList.contains('is-open')) dialog.hidden = true;
      if (opener && document.contains(opener)) opener.focus({ preventScroll: true });
    }

    if (immediate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) finishClose();
    else teamDialogTimer = window.setTimeout(finishClose, 240);
  }

  function openTeamDialog(dialog, opener) {
    if (!dialog || activeTeamDialog === dialog) return;
    if (activeTeamDialog) closeTeamDialog(activeTeamDialog, true);

    window.clearTimeout(teamDialogTimer);
    activeTeamDialog = dialog;
    activeTeamDialogOpener = opener;
    dialog.hidden = false;
    dialog.setAttribute('aria-hidden', 'false');
    lockTeamDialogScroll(true);

    window.requestAnimationFrame(function () {
      dialog.classList.add('is-open');
      var closeButton = dialog.querySelector('.ei2026__team-dialog-close');
      if (closeButton) closeButton.focus({ preventScroll: true });
      else dialog.focus({ preventScroll: true });
    });
  }

  function initTeamDialogs(root) {
    var openers = root.querySelectorAll ? root.querySelectorAll('[data-ei-team-open]') : [];

    Array.prototype.forEach.call(openers, function (opener) {
      if (opener.dataset.eiTeamDialogReady === 'true') return;
      opener.dataset.eiTeamDialogReady = 'true';

      opener.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        var card = opener.closest('[data-ei-team-card]');
        if (card) {
          card.dispatchEvent(new CustomEvent('empire:team-card-selected', { bubbles: true }));
        }

        openTeamDialog(document.getElementById(opener.getAttribute('data-ei-team-open')), opener);
      });
    });

    var dialogs = root.querySelectorAll ? root.querySelectorAll('[data-ei-team-dialog]') : [];
    Array.prototype.forEach.call(dialogs, function (dialog) {
      if (dialog.dataset.eiTeamDialogReady === 'true') return;
      dialog.dataset.eiTeamDialogReady = 'true';

      dialog.addEventListener('click', function (event) {
        if (!event.target.closest('[data-ei-team-close]')) return;
        event.preventDefault();
        closeTeamDialog(dialog, false);
      });
    });
  }

  document.addEventListener('keydown', function (event) {
    if (!activeTeamDialog) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeTeamDialog(activeTeamDialog, false);
      return;
    }

    if (event.key !== 'Tab') return;
    var focusable = Array.prototype.slice.call(activeTeamDialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter(function (element) {
      return element.offsetParent !== null;
    });
    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  function initTeamCarousel(root) {
    var carousels = root.querySelectorAll ? root.querySelectorAll('[data-ei-team-carousel]') : [];

    Array.prototype.forEach.call(carousels, function (carousel) {
      if (carousel.dataset.eiCarouselReady === 'true') return;

      var viewport = carousel.querySelector('[data-ei-team-viewport]');
      var cards = Array.prototype.slice.call(carousel.querySelectorAll('[data-ei-team-card]'));
      var previous = carousel.querySelector('[data-ei-team-prev]');
      var next = carousel.querySelector('[data-ei-team-next]');
      var counter = carousel.querySelector('[data-ei-team-counter]');

      if (!viewport || cards.length < 2) return;
      carousel.dataset.eiCarouselReady = 'true';

      var selectedIndex = 0;
      var frame = 0;
      var programmaticUntil = 0;
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var drag = null;
      var pointerMoved = false;

      function clamp(index) {
        return Math.max(0, Math.min(cards.length - 1, index));
      }

      function isMultiCardDesktop() {
        if (!cards.length) return false;
        return window.matchMedia('(min-width: 990px)').matches && viewport.clientWidth > (cards[0].offsetWidth * 1.35);
      }

      function maxScrollLeft() {
        return Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      }

      function cardScrollLeft(index) {
        var card = cards[clamp(index)];
        if (!card) return 0;

        var targetLeft;

        if (isMultiCardDesktop()) {
          targetLeft = card.offsetLeft;
        } else {
          targetLeft = card.offsetLeft + (card.offsetWidth / 2) - (viewport.clientWidth / 2);
        }

        return Math.max(0, Math.min(maxScrollLeft(), targetLeft));
      }

      function render(index) {
        selectedIndex = clamp(index);
        cards.forEach(function (card, cardIndex) {
          var isSelected = cardIndex === selectedIndex;
          card.classList.toggle('is-selected', isSelected);
          if (isSelected) card.setAttribute('aria-current', 'true');
          else card.removeAttribute('aria-current');
        });
        if (counter) counter.textContent = (selectedIndex + 1) + ' / ' + cards.length;
      }

      function select(index, moveViewport) {
        render(index);
        if (!moveViewport) return;
        programmaticUntil = Date.now() + (reducedMotion ? 80 : 620);
        viewport.scrollTo({
          left: cardScrollLeft(selectedIndex),
          behavior: reducedMotion ? 'auto' : 'smooth'
        });
      }

      function closestIndex() {
        var currentScroll = viewport.scrollLeft;
        var closest = selectedIndex;
        var closestDistance = Infinity;

        cards.forEach(function (card, index) {
          var target = cardScrollLeft(index);
          var distance = Math.abs(target - currentScroll);
          if (distance < closestDistance) {
            closest = index;
            closestDistance = distance;
          }
        });

        return clamp(closest);
      }

      function updateFromScroll() {
        frame = 0;
        if (Date.now() < programmaticUntil) return;
        render(closestIndex());
      }

      viewport.addEventListener('scroll', function () {
        if (frame) return;
        frame = window.requestAnimationFrame(updateFromScroll);
      }, { passive: true });

      cards.forEach(function (card, index) {
        function selectThisCard() {
          select(index, true);
        }

        card.addEventListener('empire:team-card-selected', function () {
          selectThisCard();
        });

        card.addEventListener('click', function (event) {
          if (pointerMoved) return;

          /*
            Corrección:
            Ahora cualquier tarjeta visible se puede seleccionar directamente.
            Si el clic es en el botón "Meer", primero selecciona esa tarjeta
            y después el listener del modal abre la información ampliada.
          */
          selectThisCard();
        });

        card.addEventListener('focus', function () {
          render(index);
        });
      });

      if (previous) previous.addEventListener('click', function (event) {
        event.preventDefault();
        select(closestIndex() - 1, true);
      });

      if (next) next.addEventListener('click', function (event) {
        event.preventDefault();
        select(closestIndex() + 1, true);
      });

      viewport.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        select(closestIndex() + (event.key === 'ArrowRight' ? 1 : -1), true);
      });

      viewport.addEventListener('pointerdown', function (event) {
        pointerMoved = false;

        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        if (event.target.closest('button, a, input, textarea, select, summary')) return;

        drag = {
          id: event.pointerId,
          x: event.clientX,
          scrollLeft: viewport.scrollLeft
        };

        viewport.classList.add('is-dragging');
        viewport.setPointerCapture(event.pointerId);
      });

      viewport.addEventListener('pointermove', function (event) {
        if (!drag || drag.id !== event.pointerId) return;

        var deltaX = event.clientX - drag.x;

        if (Math.abs(deltaX) > 4) {
          pointerMoved = true;
        }

        viewport.scrollLeft = drag.scrollLeft - deltaX;
      });

      function finishDrag(event) {
        if (!drag || drag.id !== event.pointerId) return;
        drag = null;
        viewport.classList.remove('is-dragging');

        if (pointerMoved) {
          select(closestIndex(), true);
          window.setTimeout(function () {
            pointerMoved = false;
          }, 80);
        }
      }

      viewport.addEventListener('pointerup', finishDrag);
      viewport.addEventListener('pointercancel', finishDrag);

      window.addEventListener('resize', function () {
        window.clearTimeout(initTeamCarousel._resizeTimer);
        initTeamCarousel._resizeTimer = window.setTimeout(function () {
          select(selectedIndex, true);
        }, 160);
      }, { passive: true });

      window.requestAnimationFrame(function () { select(0, true); });
    });
  }

  function init() {
    initTeamCarousel(document);
    initTeamDialogs(document);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', function (event) {
    initTeamCarousel(event.target);
    initTeamDialogs(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    if (activeTeamDialog && event.target.contains(activeTeamDialog)) closeTeamDialog(activeTeamDialog, true);
  });
  document.addEventListener('shopify:block:select', function (event) {
    var card = document.querySelector('[data-block-id="' + event.detail.blockId + '"]');
    if (card) {
      card.dispatchEvent(new CustomEvent('empire:team-card-selected', { bubbles: true }));
      card.focus({ preventScroll: true });
    }
  });
})();